import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const InstitutionalPage = lazy(() => import('../pages/institutional/page'));
const DigitalStudioPage = lazy(() => import('../pages/studio-digital/page'));
const TeamPage = lazy(() => import('../pages/team/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/conseil-institutionnel',
    element: <InstitutionalPage />
  },
  {
    path: '/studio-digital',
    element: <DigitalStudioPage />
  },
  {
    path: '/equipe',
    element: <TeamPage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;